import { css } from '@emotion/css';

export const checkboxStyles = css`
  &.MuiCheckbox-colorSecondary.Mui-checked:hover {
    background-color: transparent;
  }
  &.MuiIconButton-colorSecondary:hover {
    background-color: transparent;
  }
`;
